<template>
  <div>
    <Index v-if="this.$store.getters.isOturum"></Index>
    <Giris v-if="!this.$store.getters.isOturum && this.$route.path=='/giris'"></Giris>
    <Kayit v-if="!this.$store.getters.isOturum && this.$route.path=='/kayit'"></Kayit>
  </div>
</template>
<script>
import Index from './comp/Index'
import Giris from './pages/Giris/Index'
import Kayit from './pages/Kayit/Index'

export default {
  components: {
    Index,
    Giris,
    Kayit,
  },
  data() {
    return {
      lo: false,
      Logo: null
    }
  },
  beforeCreate() {
  },
  created() {
    console.log(this.$route.path);
    this.$store.dispatch("initAuth");
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue